// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Mf0u","buttons":"styles_buttons__1CkbM"};